<template id="table-resultados">
    <div>
        <simple-table
            :rows="rows"
            :columns="columns"
            :perPage="[10, 25, 50, 100]"
            :classes="tableClasses"
        >
            <tbody slot="body" slot-scope="{ data }">
                <tr :key="item.id" v-for="item in data">
                    <template v-if="tab == 'diasFestivos'">
                        <td>
                            <div v-if="rol == 'root'">
                                {{ item.nombre_cliente }}
                            </div>
                            <div v-if="rol == 'root'" class="tblSecundario">
                                {{ item.nombre_empresa }}
                            </div>

                            <div v-if="rol == 'admin'" class="tblPrincipal">
                                {{ item.nombre_empresa }}
                            </div>
                            <div v-if="rol == 'admin'" class="tblSecundario">
                                {{ item.nombre_sucursal }}
                            </div>

                            <div v-if="rol == 'admin-empresa' || rol == 'admin-sucursal' || rol == 'admin-depto'" class="tblPrincipal">
                                {{ item.nombre }}
                            </div>
                        </td>

                        <td>
                            <div class="tblPrincipal">{{ item.descripcion }}</div>
                        </td>
                        <td>
                            <div class="tblPrincipal">{{ dateFormat(item.fecha) }}</div>
                        </td>
                        <td  v-if="rol != 'admin-depto'">
                            <div class="tblOpciones">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" class="botonHover" icon fab dark small @click="abrirModal('update', item)">
                                            <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="permisos.delete">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" class="botonHover" icon fab dark small @click="eliminar(item)">
                                            <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </template>
                </tr>
            </tbody>
        </simple-table>

        <template>
            <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <ValidationObserver ref="form" v-slot="{ invalid }">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagen" class="imgModal" />
                                    <h2 class="titleModal">{{ tituloModal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="isLoadingModal">
                                    <div id="loading">
                                        <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                    </div>
                                </div>

                                <v-container v-show="!isLoadingModal" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col xs="12" sm="8" md="8" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Nombre" rules="required">
                                                <v-text-field 
                                                    outlined 
                                                    label="Nombre" 
                                                    class="pa-0 ma-0" 
                                                    v-model="diaFestivo.nombre" 
                                                    :error-messages="errors" 
                                                    required
                                                >
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>

                                        <v-col xs="8" sm="4" md="4" class="py-0">
                                            <VuetifyDatePicker
                                                outlined
                                                rules="required"
                                                :valorDefecto="diaFestivo.fecha"
                                                v-model="diaFestivo.fecha"
                                                label="Fecha"
                                                placeholder="dd/mm/aaaa"
                                                ref="Fecha"
                                            />
                                        </v-col>
                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Cliente"
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        persistent-hint
                                                        v-model="cliente_value"
                                                        class="pa-0 ma-0"
                                                        required 
                                                        :error-messages="errors" 
                                                        no-data-text="Datos no disponibles"
                                                    >
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <v-col
                                            v-if="rol == 'root' || rol == 'admin'" 
                                            cols="12" xs="12" sm="12" md="12" 
                                            class="py-0"
                                        >
                                            <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                <v-autocomplete
                                                    outlined
                                                    label="Empresa"
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    persistent-hint
                                                    v-model="empresa_value"
                                                    class="pa-0 ma-0"
                                                    required 
                                                    :error-messages="errors" 
                                                    no-data-text="Datos no disponibles"
                                                >
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>

                                        <template>
                                            <v-col 
                                                v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'"
                                                cols="12" xs="12" sm="12" md="12" 
                                                class="py-0"
                                            >
                                                <VuetifyMultipleAutocomplete
                                                    outlined
                                                    :items="sucursales"
                                                    :valorDefecto="sucursalesSeleccionadas"
                                                    item_text="nombre"
                                                    @dataMultiple="(data)=> sucursalesSeleccionadas = data"
                                                    label="Sucursales"
                                                    ref="multSucursal"
                                                    :rules="'required'"
                                                />
                                            </v-col>
                                        </template>

                                        <template>
                                            <v-col xs="12" sm="12" md="12" class="py-0">
                                                <VuetifyMultipleAutocomplete
                                                    outlined
                                                    :items="departamentos"
                                                    :valorDefecto="departamentos_value"
                                                    item_text="nombre"
                                                    @dataMultiple="(data)=> departamentos_value = data"
                                                    label="Departamentos"
                                                    ref="multDepto"
                                                />
                                            </v-col>
                                        </template>
                                        <v-col xs="12" sm="12" md="12" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Descripción" rules="required">
                                                <v-textarea
                                                    outlined
                                                    rows="2"
                                                    label="Descripción"
                                                    v-model="diaFestivo.descripcion"
                                                    :error-messages="errors"
                                                ></v-textarea>
                                            </ValidationProvider>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()" 
                                    :disabled="isSaving"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()" 
                                    :disabled="invalid" 
                                    :loading="isSaving"
                                    v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                            <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                    
                                >
                                    El usuario no tiene permiso para editar el registro.
                                </v-alert>
                            </div>
                        </ValidationObserver>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Datatable from "@/components/simpletable/Datatable.vue";
import clienteAPi from '@/api/clientes';
import empresaApi from '@/api/empresas';
import sucursalApi from '@/api/sucursales';
import departamentoApi from "@/api/departamentos";
import festivoApi from "@/api/dias_festivos";
import Notify from '@/plugins/notify';
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import VuetifyMultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2.vue';

export default {
    components: {
        'simple-table': Datatable,
        VuetifyDatePicker,
        VuetifyMultipleAutocomplete,
    },
    props: {
        tab: String,
        rol: {
            type: String,
            default: ''
        },
        columns: Array,
        rows: Array,
    },
    data() {
        return {
            tableClasses: {
                "t-head" : {
                    "tamanio-head":true
                }
            },
            diaFestivo          : {
                id              : 0,
                nombre          : "",
                fecha           : "",
                descripcion     : "",
                cliente_id      : null,
                empresa_id      : null,
                sucursales      : [],
                departamentos   : [],
            },
            accion          : null,
            tituloModal     : null,
            dialog          : false,
            isSaving        : false,
            clientes        : [],
            empresas        : [],
            sucursales      : [],
            departamentos   : [],
            cliente_value   : null,
            empresa_value   : null,
            sucursal_value  : null,
            departamentos_value: [],
            sucursalesSeleccionadas: [],
            imagen          : '',
            datosLogin      : null,
            isUpdate        : false,
            isLoadingModal  : true,

            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        }
    },
    watch: {
        cliente_value: function(val){
            this.cambiaCliente(val);
        },
        empresa_value: function(val){
            
            if(this.isUpdate){
                this.sucursalesSeleccionadas = [];
            }
            this.cambiaEmpresa(val);
        },
        sucursalesSeleccionadas:{
            deep:true,  
            handler(val, oldVal){

                if(this.isUpdate){
                    this.departamentos_value = [];
                }
                this.cambiaSucursales(val);
            }
        },
    },
    methods: {
        dateFormat(fecha) {
            let fecha2 = fecha.split("-");
            return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
        },

        async abrirModal(accion, data = null){
            this.accion     = accion;
            await this.resetValue();
            this.isLoadingModal = true;

            this.tituloModal = "Actualizar día festivo";
            this.imagen = "/static/modal/diaFestivoUpdate.svg";
            this.isUpdate = false
            await festivoApi.getDia(data.id).then((response) => {
                this.diaFestivo.id              = response.id;
                this.diaFestivo.nombre          = response.nombre;
                this.diaFestivo.fecha           = response.fecha;
                this.diaFestivo.descripcion     = response.descripcion;
                this.diaFestivo.cliente_id      = response.cliente_id;
                this.diaFestivo.empresa_id      = response.empresa_id;
                this.sucursalesSeleccionadas    = response.sucursales;
                this.departamentos_value        = response.departamentos;
                
                setTimeout(()=>{
                    this.isUpdate = true
                    this.isLoadingModal = false;
                },3000);
            })
            .catch((err) => {
                this.isLoadingModal = false;
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }
                    Notify.ErrorToast(leyenda);
                }
            });
            setTimeout(()=>this.$refs.Fecha.setDate(data.fecha),200);


            if (this.rol == "root") {
                await this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                await this.cambiaCliente(this.datosLogin.cliente_id);
            } else if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                await this.cambiaEmpresa(this.datosLogin.empresa_id);
            } else if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.sucursal_value = this.datosLogin.sucursal_id;
            }
            setTimeout(()=>{ document.getElementById("btnModal").click(); }, 100);
        },
        cerrarModal() {
            this.dialog = false;
            this.isSaving = false;
            this.cliente_value = null;
            this.empresa_value = null;
            this.departamentos_value = null;
            this.resetValue();
        },
        async resetValue() {
            this.diaFestivo     = {
                id              : 0,
                nombre          : "",
                fecha           : "",
                descripcion     : "",
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamentos   : [],
            };
            

            this.$nextTick(() => { 
                this.cliente_value              = null;
                this.empresa_value              = null;
                this.clientes                   = [];
                this.empresas                   = [];
                this.sucursales                 = [];
                this.departamentos_value        = [];
                this.departamentos              = [];
                this.sucursalesSeleccionadas    = [];
                this.isUpdate                   = true;
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                }
            });
        },
        getClientes(cliente = null) {
            let param = { activo: true, paginate: false }
            clienteAPi.getClientes(param).then((response) => {
                this.clientes = response.data;
                if (this.diaFestivo.cliente_id != null) {
                    this.cliente_value = this.diaFestivo.cliente_id;
                }
            })
            .catch(error => {
                this.resetValue();
                Notify.ErrorToast(error.response.data.error);
            });
        },
        async cambiaCliente(id, cliente = null) {
            if(id == null){
                return;
            }
            let parametros = { activo: true, paginate: false, cliente_id: id };
            await empresaApi.getEmpresas(parametros).then((response)=>{
                this.empresas = response.data;
                if (this.diaFestivo.empresa_id != null) {
                    this.empresa_value = this.diaFestivo.empresa_id;
                }
            })
            .catch(error => {
                console.log(error);
                Notify.ErrorToast("Ocurrio un error al cargar las empresas.");
            });
        },
        async cambiaEmpresa(id, sucursal = null) {
            if(id == null){
                return;
            }
            
            let parametros = { activo:true, paginate: false, empresa_id: id }
            await sucursalApi.getSucursales(parametros).then((response)=>{
                this.sucursales = response.data;
                
            })
            .catch(error => {
                this.resetValue();
                Notify.ErrorToast(error.response.data.error);
            });
        },
        cambiaSucursales(items) {
            if(items.length == 0){
                this.departamentos = [];
                return;
            }
            
            let parametros = { activo: true, paginate: false, arraySucursal: JSON.stringify(items) };
            departamentoApi.getDepartamentos(parametros).then((response)=>{
                this.departamentos = response.data;
                this.departamentos.map(depto => depto.nombre += " - "+depto.nombre_sucursal);
            })
            .catch(error => {
                Notify.ErrorToast(error);
            });
        },
        guardar() {
            this.$refs.form.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }

                this.diaFestivo.cliente_id      = this.cliente_value;
                this.diaFestivo.empresa_id      = this.empresa_value;
                this.diaFestivo.sucursal_id     = this.sucursal_value;
                
    

                this.diaFestivo.sucursales =  this.sucursalesSeleccionadas;
                this.diaFestivo.departamentos = this.departamentos_value;

                festivoApi.updateDia(this.diaFestivo).then((response) => {
                    Notify.Success("Operación exitosa", "Se ha actualizado el día festivo satisfactoriamente.");
                    
                    this.cerrarModal();
                    this.$nextTick(() => {
                        this.$emit('updateSearch', 'diasFestivos');
                        this.$refs.form.reset();
                    });
                })
                .catch(err => {
                    this.isSaving = false;
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error);
                    }else{
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                            leyenda+= `* ` + error[i] + `\n`;
                        }

                        Notify.ErrorToast(leyenda);
                    }
                    });
                
            });
        },
        eliminar(data){
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el día festivo " + data.nombre + "?",
                "Eliminar",
                () => {
                    festivoApi.deleteDia(data.id).then(response => {
                        Notify.Success("Operación exitosa", "El día festivo ha sido eliminado satisfactoriamente");
                        this.$emit('updateSearch', 'diasFestivos');
                    })
                    .catch(err => {
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            )
        },

        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("dias-festivos.store")
            this.permisos.update = permisosStorage.includes("dias-festivos.update")
            this.permisos.delete = permisosStorage.includes("dias-festivos.delete")
        }
    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.permisosVista();
    },
}
</script>

<style>
    .fechas{
        font-size: 70%;
        font-style: oblique;
    }

</style>